<template>
    <div class="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
        <h1 class="text-3xl font-bold text-gray-900 mb-8">Third Party Notices</h1>
        
        <div class="prose prose-slate max-w-none">
            <p>
                This application uses the following third-party open source software. We are grateful to the authors and contributors of these projects.
            </p>

            <div class="my-8">
                <div class="border-b border-gray-200 py-4">
                    <h2 class="text-2xl font-bold text-gray-900 mb-2 mt-0">heic-to</h2>
                    <p class="text-gray-600 mb-2">
                        Copyright (c) 2024 Hopper Gee
                    </p>
                    <p class="text-gray-600 mb-4">
                        Licensed under the <a href="https://www.gnu.org/licenses/lgpl-3.0.en.html" target="_blank" rel="noopener noreferrer">LGPL-3.0 License</a>.
                    </p>
                    <div class="bg-gray-50 p-4 rounded-md text-sm font-mono overflow-x-auto text-gray-700 border border-gray-200">
                        This library is free software; you can redistribute it and/or modify it under the terms of the GNU Lesser General Public License as published by the Free Software Foundation; either version 3 of the License, or (at your option) any later version.<br><br>
                        This library is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more details.
                    </div>
                    <p class="mt-4 text-sm">
                        <a href="https://github.com/hoppergee/heic-to" target="_blank" rel="noopener noreferrer" class="text-primary-600 hover:text-primary-800">
                            View Source Code
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
definePageMeta({
    layout: 'default'
})
useHead({
    title: 'Third Party Notices | ClaimReady'
})
</script>
